import React from 'react';
import { View } from 'react-native-web';
import RadiusBar from './RadiusBar';
import RegularText from '../Text/RegularText';

//= ========================================================================

const RadiusContainer = ({
  globJSON,
  onConfigChanged,
  object,
}) => (
  <View>
    <RegularText>{object.text}</RegularText>
    <RadiusBar
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      isSquare={object.isSquare}
      isSelected={globJSON.configurations.theme.radius.elements_shape_square === object.isSquare}
    />
  </View>
);
export default RadiusContainer;
